import { useEffect, useRef } from 'react';
import { GtmPageViewEventType } from 'types/gtm';
import { useGtmContext } from 'utils/Gtm/context/GtmProvider';
import { gtmSafePushEvent } from 'utils/Gtm/Gtm';

export const useGtmFriendlyPageView = (event: GtmPageViewEventType, slug: string, fetching: boolean): void => {
    const lastViewedFriendlyPageSlug = useRef<string | undefined>(undefined);
    const { setDidPageViewRun } = useGtmContext();

    useEffect(() => {
        if (event._isLoaded && lastViewedFriendlyPageSlug.current !== slug && !fetching) {
            lastViewedFriendlyPageSlug.current = slug;
            gtmSafePushEvent(event);
            setDidPageViewRun(true);
        }
    }, [event, fetching, slug, setDidPageViewRun]);
};
